import styled from 'styled-components'
import { theme } from '@acorns/grove'
import { Drawer } from '@acorns/web-components'
import Markdown from 'react-markdown'
import AgreementModal from 'components/AgreementModal'

const DRAWER_MOBILE_BREAKPOINT = 420

export const DrawerTitle = styled.div`
  font-size: 30px;
  font-weight: 600;
  line-height: 38px;
  margin-top: 20px;
`

export const StyledDrawer = styled(Drawer)`
  @media (min-width: ${DRAWER_MOBILE_BREAKPOINT + 1}px) {
    padding: 0;
    background-color: ${theme.colors.naturalCloud};
  }

  @media (max-width: ${DRAWER_MOBILE_BREAKPOINT}px) {
    > div {
      padding: 0;
      background-color: ${theme.colors.naturalCloud};
    }
  }

  header {
    padding: 30px 30px 0 30px;
    button {
      background-color: ${theme.colors.primaryWhite};
    }

    @media (min-width: ${DRAWER_MOBILE_BREAKPOINT + 1}px) {
      padding: 40px 40px 0 40px;
    }
  }
`

export const DrawerBody = styled(Markdown as any)`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;

  a {
    color: ${theme.colors.primaryStone};
    text-decoration: unset;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
  }
`

export const DrawerContentContainer = styled.div`
  padding: 0 30px;
  text-align: left;
  white-space: pre-line;

  @media (min-width: ${DRAWER_MOBILE_BREAKPOINT + 1}px) {
    padding: 0 40px;
  }
`

export const DrawerImage = styled.img`
  width: 100%;
  margin-bottom: -5px;
`

export const StyledAgreementModal = styled(AgreementModal)`
  z-index: 600;

  > div:nth-child(2) {
    position: fixed;
    max-width: unset;
    width: calc(100% - 40px);
    max-height: 580px;
    bottom: 10%;
    border-radius: 10px;
  }

  @media (min-width: ${theme.dimensions.breakpointsSmall + 1}px) {
    > div:nth-child(2) {
      max-width: 380px;
      max-height: unset;
      height: calc(100% - 200px);
      bottom: unset;
    }
  }
`
